<script>
    import { TRACKING_PROPERTIES_KEY, RESULT_MAPPING_KEY } from '$lib/global/constants';

    import getQueryParameter from '$lib/global/helper/get-query-parameter';
    import { setTrackingProperty } from '$lib/helper';

    import { onMount } from 'svelte';

    export let resultPages = [];
    export let campaignId = '';

    // This happens only on refresh/initial load of the funnel
    // since the component only mounts once in layout
    onMount(() => {
        const ST = window.sessionStorage;
        const ResultMappingKey = `${RESULT_MAPPING_KEY}${campaignId}`;
        const TrackingPropertiesKey = `${TRACKING_PROPERTIES_KEY}${campaignId}`;

        // Init Result mapping
        const pageCounts = {};
        resultPages.forEach((resultPage) => {
            pageCounts[resultPage] = 0;
        });
        ST.setItem(ResultMappingKey, JSON.stringify(pageCounts));

        // Init Tracking properties which is used for
        // - (text) personalization
        // - and HTML block variable interpolation
        const queryParams = getQueryParameter();

        ST.setItem(TrackingPropertiesKey, JSON.stringify({}));

        Object.keys(queryParams.custom).forEach((param) => {
            setTrackingProperty(param, queryParams.custom[param], campaignId);
        });

        // FUN-800: We want to support HTML Block code interpolation for UTM parameters too.
        Object.keys(queryParams.utm).forEach((param) => {
            setTrackingProperty(param, queryParams.utm[param], campaignId);
        });
    });
</script>
